/** The chat's voice slot: `audio/mp4` (M4A) only, 25 MiB and five minutes; the phone's 64 kbps mono. */
export const VOICE_CLASS = {
  contentType: 'audio/mp4',
  maxBytes: 26_214_400,
  maxDurationSeconds: 300,
  bitrate: 64_000,
} as const;
